import { ThemeType } from '../../../theming/jssTypes';

const styles = (theme: ThemeType): any => ({
  tabsCardsContainer: {
      backgroundColor: theme.color.semantic.background.neutral.secondary,
      borderRadius: theme.radius.sm,
      padding: theme.spacing[0],
      overflow: 'scroll',
      height: '100%',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
  },
  tableContainer: {
    flex: '1 1 0',
    overflow: 'auto',
    height: 300,
    boxShadow: theme.shadow.sm,
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: theme.spacing[2],
    },
  },
});

export default styles;
